const getInitialEsignSelfie = () => ({
  status: "pending",
  image: null,
});

const initialLoanState = {
  loanId: null,
  esignSelfie: getInitialEsignSelfie(),
  sanctionBankAccountNum: null,
  sanctionBankName: null,
  esignDocId: null,
  enachSkipAllowed: null,
};

export const createLoanSlice = (set) => ({
  ...initialLoanState,
  setLoanId: (loanId) => set(() => ({ loanId })),
  setSanctionBankDetails: (accountNum, bankName) =>
    set(() => ({ sanctionBankAccountNum: accountNum, sanctionBankName: bankName })),
  setEsignDocId: (esignDocId) => set(() => ({ esignDocId })),
  setEnachSkipAllowed: (enachSkipAllowed) => set(() => ({ enachSkipAllowed })),
  updateEsignSelfie: (status, image) =>
    set(() => ({
      esignSelfie: {
        status,
        image: image ?? null,
      },
    })),
  clearLoanData: () =>
    set(() => ({
      ...initialLoanState,
      esignSelfie: getInitialEsignSelfie(),
    })),
});
